<div class="content-container">
    <h2 i18n>Select Gedcom files</h2>
    <div *ngIf="officialGedcom.length >= 1">
        <div *ngFor="let gedcom of officialGedcom; let i = index" class="row">
            <input type="checkbox" name="gedcom" value="gedcom.selected" [(ngModel)]="gedcom.selected">
            <label for="gedcom">{{gedcom.name}}</label>
        </div>
    </div>
    <div *ngIf="officialGedcom.length <= 0">
        <p i18n>No new public gedcoms avilable</p>
    </div>
    <div class="button-container">
            <button i18n *ngIf="officialGedcom.length >= 1" (click)="SelectGedcoms()"  >Add files</button>
            <button i18n (click)="dialogRef.close(true)">Cancel</button>
    </div>
</div>